import { useMember } from "api/members";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { MemberForm } from "./MemberForm";
import { useStyles } from "./MemberForm.styles";

export function EditMember() {
  const classes = useStyles();
  const { message } = useMessage();
  const { id: memberID } = useParams<{ id: string }>();
  const { useMembersData } = useMember(memberID);
  const { data: membersData } = useMembersData();

  const memberHasName =
    membersData &&
    (membersData.firstName?.length > 0 || membersData.lastName?.length > 0);

  const breadcrumbs: Breadcrumbs =
    membersData && memberHasName
      ? {
          parent: {
            label: `${membersData?.firstName} ${membersData?.lastName}`,
            path: links.singleMemberGeneralInfo(membersData?.customerId),
          },
        }
      : undefined;

  return (
    <>
      <TopHeader
        title={membersData ? message({ id: "editMember" }) : ""}
        clearLink={links.membersList}
        breadcrumbs={breadcrumbs}
        data-hj-suppress
      />
      <div className={classes.formWrapper}>
        <MemberForm editMode initialValues={membersData} />
      </div>
    </>
  );
}
